<template>
  <v-card flat>
    <v-form ref="form" v-model="valid" lazy-validation>
      <h1>{{ $t("application.instructor.date.title") }}</h1>
      <p>{{ $t("application.instructor.date.info") }}</p>

      <div class="overline">{{ $t("application.instructor.date.form-title") }}</div>
      <!-- choose application employment type  -->
      <div class="mt-n2">
        <v-radio-group
          v-model="application.employmentTypeId"
          :key="application.employmentTypeId"
          column
        >
          <v-radio
            name="application.employmentTypeId"
            :label="$t('application.instructor.date.check1')"
            :value="1"
            key="1"
          ></v-radio>
          <v-radio
            name="application.employmentTypeId"
            :label="$t('application.instructor.date.check2')"
            :value="2"
            key="2"
          ></v-radio>
        </v-radio-group>
      </div>
      <!-- Pick a date for application start -->
      <v-row class="mt-1">
        <v-col cols="6" md="12">
          <DatePicker
            label="Startdatum"
            v-model="application.employmentDate"
            :placeholder="$t('application.instructor.date.date-placeholder')"
          />
        </v-col>
      </v-row>
      
      <p class="mt-n4 mb-10">{{ $t("application.instructor.date.info2") }}</p>

      <NextButton
        :isDisabled="
          application.employmentDate == null || application.employmentTypeId < 0
        "
        class=""
        @click="nextStep"
        >{{ $t("tour.next") }}</NextButton
      >
      <BottomNav @clicked="$emit('goToStep', '-1')" />
    </v-form>
  </v-card>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import pick from "lodash/pick";
import { RulesMixin } from "@/components/mixins";
import DatePicker from "@/components/Common/DatePicker";
import NextButton from "@/components/Common/NextButton";
import BottomNav from "@/components/Application/BottomNav";

// @group Application-Company
// ApplicationDate component
export default {
  name: "ApplicationDate",

  mixins: [RulesMixin],

  components: {
    NextButton,
    BottomNav,
    DatePicker,
  },

  data: () => ({
    dissBtn: true,
    application: {
      id: null,
      employmentTypeId: null,
      employmentDate: null,
    },
    valid: false,
  }),

  created() {
    /**
     * @vuese
     * Used to call init fúnction
     */
    this.initApplication();
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication , reset validation  and call initApplication function
     */
    selectedApplication: {
      handler: function () {
        this.initApplication();
      },
      deep: true,
    },
    /**
     * @vuese
     * Used to watch the currentStep and call initApplication
     * @arg called with no argument
     */
    currentStep: {
      handler: function () {
        this.initApplication();
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters("application", ["currentStep", "selectedApplication"]),
    ...mapGetters("currentuser", ["currentUser"]),
  },

  methods: {
    ...mapActions("application", ["setSelectedApplication", "updateSelectedApplication"]),

    /**
     * @vuese
     * Used to Initialize application with either selected fields or empty fields
     */
    initApplication() {
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application.id = this.selectedApplication.id;
        this.application.employmentTypeId = this.selectedApplication.employmentTypeId;
        this.application.employmentDate = this.selectedApplication.employmentDate;
      }
      this.application.step = this.currentStep;
    },

    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias
     * @arg The argument is an integer value application  id and params are the selected fields
     */
    async nextStep() {
      if(!(this.application.employmentDate && this.application.employmentTypeId))
        return

      if (this.application.id && this.application.id > 0) {
        API.updateApplication(this.application.id, { data: this.application })
          .then(() => {
            /**
             * @vuese
             * Used to update application in vuex store
             * @arg The params are current fields of the application
             */
            this.updateSelectedApplication(this.application);
            // Fire +1
            // @arg The argument is a integer representing (in which step to go)

            this.$emit("goToStep", "+1");
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));
          });
      }
    },
  },
};
</script>

<style scoped></style>
